import { Tile } from "./TileDisplay";
import { ResponsiveChartContainer, ChartsXAxis, ChartsTooltip, ChartsLegend, ChartsYAxis, BarSeriesType, BarPlot } from '@mui/x-charts';
import moment from 'moment';
import { WithTitle } from "./TileDisplay";
import { ChartsNoDataOverlay, ChartsOverlay } from "@mui/x-charts/ChartsOverlay";

export function BarChart({ tile, valueKeys }: { tile: Tile; valueKeys: string[] }) {

    const barSeries: BarSeriesType[] = valueKeys.map(key => ({
        type: 'bar',
        label: key,
        dataKey: key,
    }));

    return <>
        <WithTitle title={tile.title}>
            <div style={{ width: '100%', height: 250 }}>
                <ResponsiveChartContainer
                    xAxis={[
                        {
                            dataKey: 'timestamp',
                            id: 'x-axis-id',
                            valueFormatter: (value: string) => moment(new Date(value)).format('lll'),
                            scaleType: 'band'
                        }
                    ]}
                    yAxis={[
                        { id: 'y-axis-id' },
                    ]}
                    series={barSeries}
                    dataset={tile.data.slice(-10)}>
                    <ChartsOverlay slotProps={tile.data.length === 0 ? {noDataOverlay: {message: 'No data in this time range'}} : {}} />
                    <BarPlot />
                    <ChartsXAxis position="bottom" axisId="x-axis-id" />
                    <ChartsYAxis label="Y axis" position="left" axisId="y-axis-id" />
                    <ChartsTooltip trigger='axis' />
                    <ChartsLegend position={{ horizontal: 'right', vertical: 'top' }} />
                </ResponsiveChartContainer>
            </div>
        </WithTitle>
    </>
}